(function () {
  // ─── CONFIG ───────────────────────────────────────────────────────────────
  // These percentages are calculated from your tote photo (576×700px native):
  // Bag body width = 495px = 35cm → 14.14px/cm
  // Overlay % of image width: 9cm=22.1%, 12cm=29.5%, 18cm=44.2%
  // Bag body centre: left=49.9%, top=70.4%
const CONFIG = {
    // Measured directly from actual Shopify-served image (294x294px)
    // Bag body pixel bounds: left=82, right=210, top=135, bottom=278
    bagBody: {
      topPct:    45.92,   // 135/294
      bottomPct: 94.56,   // 278/294
      leftPct:   27.89,   // 82/294
      rightPct:  71.43,   // 210/294
    },
    sizes: {
      'Small':  9,
      'Medium': 12,
      'Large':  18,
    },
    bagWidthCm: 35
  };

  // ─── STATE ────────────────────────────────────────────────────────────────
  let currentSize     = null;   // e.g. 'Small'
  let uploadedDataURL = null;   // base64 image from Upload-Lift

  // ─── WAIT FOR DOM ─────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', init);

function init() {
    if (!window.location.pathname.includes('custom-embroidery-tote-bag')) return;

    injectCanvas();
    watchVariantSelector();
    watchUploadLift();
    disableLightbox();
  }

  // ─── INJECT CANVAS OVERLAY OVER PRODUCT IMAGE ─────────────────────────────
  function injectCanvas() {
    // Dawn's main product image is inside .product__media-item
    // We wrap it in a relative container and overlay a canvas on top
    const mediaWrap = document.querySelector(
      '.product__media-item img, .product-media-container img'
    );
    if (!mediaWrap) return;

    const parent = mediaWrap.closest(
      '.product__media-item, .product-media-container'
    );
    if (!parent) return;

    // Make parent relative so we can position canvas over it
    parent.style.position = 'relative';
    parent.style.display  = 'block';

    // Create canvas
    const canvas  = document.createElement('canvas');
    canvas.id     = 'anzu-preview-canvas';
    canvas.style.cssText = `
      position: absolute;
      top: 0; left: 0;
      width: 100%; height: 100%;
      pointer-events: none;
    `;
    parent.appendChild(canvas);
  }

  // ─── WATCH VARIANT SELECTOR (size dropdown or pills) ──────────────────────
function watchVariantSelector() {
    // Watch for Easify button selections via MutationObserver
    // Easify adds 'po-buttonOption-selected' to the selected button div
    const easifyObserver = new MutationObserver(() => {
      const selected = document.querySelector('.po-buttonOption-selected');
      if (!selected) return;
      const val = selected.textContent.trim();
      if (val) handleSizeChange(val);
    });

    easifyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // Also handle direct clicks on Easify buttons as immediate fallback
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[class*="po-buttonOption"]');
      if (!btn) return;
      const val = btn.textContent.trim();
      if (val) handleSizeChange(val);
    });

    // Also still listen for native Shopify variant changes as fallback
    document.addEventListener('variant:changed', (e) => {
      const variant = e?.detail?.variant;
      if (!variant) return;
      const title = variant.title || '';
      if (title.includes('Small'))  handleSizeChange('Small');
      if (title.includes('Medium')) handleSizeChange('Medium');
      if (title.includes('Large'))  handleSizeChange('Large');
    });
  }

  function handleSizeChange(val) {
    if (val.includes('Small'))  currentSize = 'Small';
    if (val.includes('Medium')) currentSize = 'Medium';
    if (val.includes('Large'))  currentSize = 'Large';
    renderPreview();
  }

  // ─── WATCH UPLOAD-LIFT ────────────────────────────────────────────────────
  // Upload-Lift renders a preview <img> inside its block after upload.
  // We observe the DOM for that image appearing, then grab its src.
 function watchUploadLift() {
    const observer = new MutationObserver(() => {

      // FilePond canvas preview (rendered as <canvas> inside the wrapper)
      const previewCanvas = document.querySelector(
        '.filepond--image-preview-wrapper canvas'
      );

      // FilePond also sometimes renders an <img> inside the wrapper
      const previewImg = document.querySelector(
        '.filepond--image-preview-wrapper img'
      );

      // FilePond stores the actual file — grab it directly from the input
      const fileInput = document.querySelector(
        'input[type="file"].filepond--browser, input.filepond--browser'
      );

      if (fileInput && fileInput.files && fileInput.files[0]) {
        const file = fileInput.files[0];
        // Only re-read if it's a new file
        if (file.name + file.size !== window._anzuLastFile) {
          window._anzuLastFile = file.name + file.size;
          const reader = new FileReader();
          reader.onload = (e) => {
            uploadedDataURL = e.target.result;
            renderPreview();
          };
          reader.readAsDataURL(file);
        }
        return;
      }

      // Fallback: try canvas snapshot
      if (previewCanvas && previewCanvas.width > 0) {
        try {
          const dataURL = previewCanvas.toDataURL();
          if (dataURL !== uploadedDataURL && dataURL !== 'data:,') {
            uploadedDataURL = dataURL;
            renderPreview();
          }
        } catch(e) {}
        return;
      }

      // Fallback: try img src
      if (previewImg && previewImg.src && previewImg.src !== uploadedDataURL) {
        toDataURL(previewImg.src, (dataURL) => {
          uploadedDataURL = dataURL;
          renderPreview();
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true, attributes: true });
  }

  // ─── RENDER PREVIEW ONTO CANVAS ───────────────────────────────────────────
function renderPreview() {
    const canvas = document.getElementById('anzu-preview-canvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    // Get the img element and its rendered dimensions
    const imgEl = canvas.closest(
      '.product__media-item, .product-media-container'
    )?.querySelector('img');

    if (!imgEl) return;

    const containerW = canvas.offsetWidth;
    const containerH = canvas.offsetHeight;

    canvas.width  = containerW;
    canvas.height = containerH;
    ctx.clearRect(0, 0, containerW, containerH);

    if (!uploadedDataURL) return;

    // ── Account for object-fit: cover ──────────────────────────────────────
    // The image is scaled so the smaller dimension fills the container,
    // then the excess is cropped from centre.
    const natW = imgEl.naturalWidth  || 857;
    const natH = imgEl.naturalHeight || 1042;

    const scaleX = containerW / natW;
    const scaleY = containerH / natH;
    const scale  = Math.max(scaleX, scaleY);  // cover = max

    const scaledW = natW * scale;
    const scaledH = natH * scale;

    // Offset: how much of the scaled image is cropped from top-left
    const cropX = (scaledW - containerW) / 2;
    const cropY = (scaledH - containerH) / 2;

    // ── Bag body bounds in scaled image coords ──────────────────────────────
    const bodyTopScaled    = CONFIG.bagBody.topPct    / 100 * scaledH;
    const bodyBottomScaled = CONFIG.bagBody.bottomPct / 100 * scaledH;
    const bodyLeftScaled   = CONFIG.bagBody.leftPct   / 100 * scaledW;
    const bodyRightScaled  = CONFIG.bagBody.rightPct  / 100 * scaledW;

    // Convert to container (canvas) coords by subtracting crop offset
    const bodyTopCanvas    = bodyTopScaled    - cropY;
    const bodyBottomCanvas = bodyBottomScaled - cropY;
    const bodyLeftCanvas   = bodyLeftScaled   - cropX;
    const bodyRightCanvas  = bodyRightScaled  - cropX;

    const bodyWCanvas = bodyRightCanvas - bodyLeftCanvas;   // px = 35cm
    const bodyHCanvas = bodyBottomCanvas - bodyTopCanvas;   // px = 40cm

    // ── Overlay size in canvas px ───────────────────────────────────────────
    const sizeCm     = currentSize ? CONFIG.sizes[currentSize] : CONFIG.sizes['Small'];
    const pxPerCm    = bodyWCanvas / CONFIG.bagWidthCm;
    const overlaySz  = sizeCm * pxPerCm;

    // ── Centre overlay on bag body ──────────────────────────────────────────
    const centrX = bodyLeftCanvas + bodyWCanvas / 2;
    const centrY = bodyTopCanvas  + bodyHCanvas / 2;

    const x = centrX - overlaySz / 2;
    const y = centrY - overlaySz / 2;

    // ── Draw ────────────────────────────────────────────────────────────────
    const img = new Image();
    img.onload = () => {
      ctx.save();
      ctx.beginPath();
      ctx.rect(x, y, overlaySz, overlaySz);
      ctx.clip();

      ctx.globalAlpha = 0.88;
      ctx.drawImage(img, x, y, overlaySz, overlaySz);

      ctx.globalCompositeOperation = 'multiply';
      ctx.fillStyle = 'rgba(210, 200, 185, 0.12)';
      ctx.fillRect(x, y, overlaySz, overlaySz);

      ctx.restore();

      // Dashed border
      ctx.save();
      ctx.strokeStyle = 'rgba(80, 65, 50, 0.45)';
      ctx.lineWidth   = 1.5;
      ctx.setLineDash([4, 4]);
      ctx.strokeRect(x, y, overlaySz, overlaySz);
      ctx.restore();
    };
    img.src = uploadedDataURL;
  }

  // ─── HELPER: Convert image URL to dataURL ─────────────────────────────────
  function toDataURL(url, callback) {
    // Try direct (works if same-origin or CORS-enabled)
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const c   = document.createElement('canvas');
      c.width   = img.naturalWidth;
      c.height  = img.naturalHeight;
      c.getContext('2d').drawImage(img, 0, 0);
      try {
        callback(c.toDataURL());
      } catch {
        // If CORS blocks canvas export, use blob URL from fetch
        fetch(url)
          .then(r => r.blob())
          .then(blob => {
            const reader = new FileReader();
            reader.onload = e => callback(e.target.result);
            reader.readAsDataURL(blob);
          });
      }
    };
    img.onerror = () => {
      // Fallback: use the URL directly
      callback(url);
    };
    img.src = url;
  }


function disableLightbox() {
    // Remove the lightbox trigger on the product media gallery
    // Dawn uses <a> or a button with data-fancybox or modal-opener
    const tryDisable = () => {
      // Remove modal-opener buttons in the media gallery
      document.querySelectorAll(
        '.product__media-item a[href], ' +
        '.product__media-item button[data-fancybox], ' +
        'modal-opener[data-modal*="ProductMedia"], ' +
        '.product-media-modal__opener, ' +
        '.product__media-item .product__media-toggle'
      ).forEach(el => {
        el.style.pointerEvents = 'none';
        el.setAttribute('data-anzu-disabled', 'true');
        // Remove the cursor pointer
        el.style.cursor = 'default';
      });

      // Also prevent the media gallery zoom click
      const mediaItems = document.querySelectorAll('.product__media-item');
      mediaItems.forEach(item => {
        item.style.cursor = 'default';
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, true);
      });
    };

    // Run immediately and again after a short delay
    // (Dawn lazy-loads some elements)
    tryDisable();
    setTimeout(tryDisable, 800);
    setTimeout(tryDisable, 2000);
  }


})();